module.exports = __webpack_public_path__ + "img/topics-3.8eee2a6c.png";